import { NgModule } from '@angular/core';
import { FunctionMenuComponent } from './function-menu.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    FunctionMenuComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    NgbTooltipModule,
  ],
  exports: [
    FunctionMenuComponent
  ]
})
export class FunctionMenuModule {
}
